/**
 * Carousel Component
 * @module patterns/components/slim-campaign-block
 */

import { type App } from '~/app';

import { getMainEnquiryForm } from '../form-and-content/modal-form/modal-form';
import JsController from '../js-controller';

export default (app: App) => {

    const controller = new JsController(app, 'Slim Campaign Block');
    controller.addMountFunction(() => {
        mountComponent(controller);
    })

    return controller.init();
}

export function mountComponent( controller: JsController ) {
    const fireEnquireModal = document.querySelector(`.fire-enquire-modal`);
    const modalButton = getMainEnquiryForm();
    if (modalButton && fireEnquireModal) {
        controller.addListener(fireEnquireModal, "click", (event) => {
            event.preventDefault();
            modalButton.click();
        });
    }
}
